import FRAGMENT_SHADER from "./shaders/atom.fs";
import VERTEX_SHADER from "./shaders/atom.vs";

class MaterialAtom extends THREE.ShaderMaterial {
    constructor({ color = 0xff00ff, scale = 1 } = {}) {
        color = new THREE.Color(color);

        const uniforms = {
            time: { value: 0 },
            size: { value: scale },
            color: { value: color },
            rotation: { value: 0 },
            center: { value: new THREE.Vector2(0.5, 0.5) }
        };

        const defines = {
            USE_SIZEATTENUATION: ""
        };

        super({
            transparent: true,
            depthWrite: false,
            vertexShader: VERTEX_SHADER,
            fragmentShader: FRAGMENT_SHADER,
            uniforms,
            defines,
            premultipliedAlpha: true,
            // blending: THREE.AdditiveBlending,

        });

        this._color = color;
        this._scale = scale;
    }

    get color() { return this._color; }
    // get color() { new THREE.Color(this._color); }

    clone() {
        return new MaterialAtom({ color: this._color, scale: this._scale });
    }
}

export default MaterialAtom;
export { MaterialAtom };